import { Injectable } from '@angular/core';
import { LandingPageService } from 'src/app/main/landing-page/landing-page.service';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';
import { ColdwaveMapConstants } from '../constant/coldwave-map.constant';
import { MapConstants } from 'src/app/utils/map.constant';
import * as L from 'leaflet';
import { delay } from 'rxjs/operators';
import { ColdwaveDataService } from 'src/app/main/side-bar/cold-watch/coldwave-data.service';
import { CwDataService } from './coldwave-data.service';
import { HeatIndexDataService } from 'src/app/main/side-bar/heat-index/heat-index-data.service';

@Injectable({
  providedIn: 'root'
})
export class ColdwaveMapService {
 mandalData: any;
  combinedTimeStampList: unknown[];
  tableData: {};
  districtData: {};
   constructor(
     public cwDataService: CwDataService,
     private utils: UtilsService,
     private landingService: LandingPageService,
     private coldwaveDataService: HeatIndexDataService
   ) { }
 
   createLayer(layer, gis) {
     if (layer.serviceType == 'WmsLayer') {
       return this.createWmsLayer(layer);
     } else if (layer.serviceType == 'VectorLayer') {
       return this.createVectorLayer(layer, gis);
     } else {
       return new Promise((resolve) => { resolve(true); });
     }
   }
 
   // createVectorLayer(layer, gis) {
   //   const options = {
   //     interactive: true,
   //     rendererFactory: {},
   //     opacity: 1,
   //     minZoom: 5,
   //     maxZoom: 18,
   //     pane: 'district',
   //     visible: true,
   //     transparent: true,
   //     vectorTileLayerStyles: {},
   //     getFeatureId: {}
   //   };
   //   options['rendererFactory'] = (L as any).canvas.tile;
   //   options['getFeatureId'] = (feature) => feature.properties.uuid;
   //   const promise = new Promise((resolve) => {
   //     this.dataService.getMandalData(layer['dataurl'], layer['postData']).then(data => {
   //       this.mandalData = this.formatMandalData(data, layer.hval, layer.hcat, gis);
   //       options['vectorTileLayerStyles'][layer.layerName] = () => {
   //         const style = {
   //           fill: true,
   //           weight: 0.5,
   //           opacity: 1,
   //           fillOpacity: 1,
   //           color: '#000000',
   //           fillColor: '#AAAAAA'
   //         };
   //         return style;
   //       };
   //       const url = MapConstants.GEOSERVER_WMTS_URL + '&layer=' + MapConstants.GEOSERVER_WORKSPACE_NAME + ':' + layer.layerName;
   //       layer['layer'] = (L as any).vectorGrid.protobuf(url, options);
   //       for (const uuid of Object.keys(this.mandalData)) {
   //         let color = '#AAAAAA';
   //         // if (this.mandalData[uuid]['table_data'][gis.activeGroup]) {
   //         //   color = ProjConstants.HEAT_WATCHES_LEGEND[this.mandalData[uuid]['table_data'][gis.activeGroup]['cat']];
   //         // }
   //         if (this.mandalData[uuid]['table_data'][gis.activeGroup]) {
   //             color = layer['postData'].component == ProjConstants.HEATWAVE ? ProjConstants.HEAT_INDEX_LEGEND[this.mandalData[uuid]['table_data'][gis.activeGroup]['cat']] : ProjConstants.HEAT_WATCHES_LEGEND[this.mandalData[uuid]['table_data'][gis.activeGroup]['cat']];
   //           }
   //         const style = {
   //           fill: true,
   //           weight: 0.5,
   //           opacity: 1,
   //           color: '#000000',
   //           fillColor: color,
   //           fillOpacity: 1,
   //         };
   //         // layer['layer'].setFeatureStyle(uuid, style);
   //          setTimeout(() => {
   //             layer['layer'].setFeatureStyle(uuid, style);
   //           },10)
   //           console.log("HEATWAVE LAYER::",layer);
             
   //       }
   //       resolve(layer);
   //     }
   //     );
   //   });
   //   return promise;
   // }
 
     async createVectorLayer(layer, gis) {
       let options = {}
       let style
       if (layer.layerNameType == 'STATE') {
         options = {
           interactive: true,
           rendererFactory3: {},
           opacity: 0.8,
           minZoom: 5,
           maxZoom: 8,
           pane: 'district',
           visible: true,
           transparent: true,
           vectorTileLayerStyles: {},
           getFeatureId: {}
         };
       } else if (layer.layerNameType == 'DISTRICT') {
         options = {
           interactive: true,
           rendererFactory2: {},
           opacity: 0.8,
           minZoom: 5,
           maxZoom: 8,
           pane: 'district',
           visible: true,
           transparent: true,
           vectorTileLayerStyles: {},
           getFeatureId: {}
         };
       }
       else {
         options = {
           interactive: true,
           rendererFactory1: {},
           opacity: 0.8,
           minZoom: 9,
           maxZoom: 18,
           pane: 'block',
           visible: true,
           transparent: true,
           vectorTileLayerStyles: {},
           getFeatureId: {}
         };
       }
   
       options['rendererFactory'] = (L as any).canvas.tile;
       options['getFeatureId'] = (feature) => feature.properties.UUID;
       // const promise = new Promise((resolve, reject) => {
       //   this.heatIndexDataService.getDistrictData(layer['dataurl'], layer['postData']).then(
       //     data => {
   
       //     }
       //   );
       // });
       console.log("POSTDATA::",layer);
       
       let forecastData = layer['dataurl'] ? this.coldwaveDataService.getDistrictData(layer['dataurl'], layer['postData']) : []
       let actualDataFromapi = layer['dataurl'] ? this.coldwaveDataService.getActualData('heatWatches/getObservedHeatWatchesData', layer['postData']) : []
       const timeStampSet = new Set();
   
       let promiseData = await Promise.all([forecastData, actualDataFromapi]).then(async (payloads) => {
   
         if (!isNullOrUndefined(payloads[0]) && !isNullOrUndefined(payloads[1])) {
           let data = payloads[0]
           let actualData = payloads[1]
           for (const locName of Object.keys(data)) {
             if (data[locName]['table_data'] == null || data[locName]['table_data'] == undefined) {
               continue;
             }
             for (const index of data[locName]['table_data']) {
               timeStampSet.add(index['timeStamp']);
             }
           }
           for (const locName of Object.keys(actualData)) {
             if (actualData[locName]['table_data'] == null || actualData[locName]['table_data'] == undefined) {
               continue;
             }
             for (const index of actualData[locName]['table_data']) {
               timeStampSet.add(index['timeStamp']);
             }
           }
           this.combinedTimeStampList = Array.from(timeStampSet);
           this.tableData = {};
           this.tableData = await this.formatMandalData(data, layer.hval, layer.hcat, gis, actualData);
           options['vectorTileLayerStyles'][layer.layerName] = (properties, zoom) => {
   
             if (layer.layerNameType == "DISTRICT") {
               style = {
                 fill: true,
                 weight: 0.7,
                 opacity: 1,
                 fillOpacity: 1,
                 color: '#000000',
                 fillColor: '#AAAAAA'
               };
             }
             else {
               style = {
                 fill: true,
                 weight: 2,
                 opacity: 1,
                 fillOpacity: 1,
                 color: '#000000',
                 fillColor: '#AAAAAA'
               };
             }
             return style;
           };
           if (layer['layerNameType'] == 'DISTRICT') {
             this.districtData = this.tableData
           }
           else {
             this.mandalData = this.tableData
           }
           console.log("CHECK:::",gis.activeGroup,this.tableData);
           
           const url = MapConstants.GEOSERVER_WMTS_URL + '&layer=' + MapConstants.GEOSERVER_WORKSPACE_NAME + ':' + layer.layerName;
           layer['layer'] = (L as any).vectorGrid.protobuf(url, options);
           if(Object.keys(this.tableData).length > 0) {
             for (const uuid of Object.keys(this.tableData)) {
               let color = '#AAAAAA';
               if (this.tableData[uuid]['table_data'][gis.activeGroup]) {
                 color = layer['postData'].component == ProjConstants.COLDWAVE ? ProjConstants.COLD_WATCHES_LEGEND[this.tableData[uuid]['table_data'][gis.activeGroup]['cat']] : ProjConstants.COLD_WATCHES_LEGEND[this.tableData[uuid]['table_data'][gis.activeGroup]['cat']];
               }
               let style = {
                 fill: true,
                 weight: 0.5,
                 opacity: 1,
                 color: '#000000',
                 fillColor: color,
                 fillOpacity: 1,
               };
               if (layer.layerNameType == 'BLOCKS') {
                 style['dashArray'] = '6,6'
               }
               setTimeout(() => {
                 layer['layer'].setFeatureStyle(uuid, style);
               },10)
   
             }
           }
           // let dbClick = 0;
           // gis.map.on({
           //   dblclick: (e: L.LayerEvent) => {
           //     {
           //       dbClick = 1;
           //     }
           //   }
           // });
   
           // layer['layer'].on({
           //   click: async (e: L.LayerEvent) => {
           //     {
           //       // console.log(e,"e")
           //       let properties = e.layer.properties;
           //       if (gis.map.getZoom() >= 5 && gis.map.getZoom() < 7) {
           //         gis.map.setView([properties.Latitude, properties.Longitude], 7)
           //         this.utils.setStateClicked(properties.State_UUID)     // to get the stateUUID to emit state data
           //         this.utils.setStateClickedName(properties)            // to get the name in breadcrumb
           //         // if(properties.State)
           //       }
           //       if (gis.map.getZoom() >= 7 && gis.map.getZoom() < 9) {
           //         gis.map.setView([properties.Latitude, properties.Longitude], 9)
           //         this.utils.setDistrictsClicked(properties.UUID)       //to get the DistrictUUID in order to show mandals
           //       }
           //       else {
           //         gis.map.setView([properties.Latitude, properties.Longitude])
           //         this.utils.setMandalClicked(properties.UUID)         //to zoom in to the mandal
   
           //       }
           //     }
           //   }
           // });
           return layer;
         }
       });
       return promiseData
     }
 
   createWmsLayer(layer) {
     const options = {
       layers: layer.layerName,
       opacity: 1,
       format: 'image/png',
       visible: true,
       transparent: true,
       pane: 'district',
       fadeAnimation: false,
       attribution: '<a href = \'https://mausam.imd.gov.in/\'> Data Source : IMD </a>'
     };
     if (layer.pane != null && layer.pane != undefined) {
       options['pane'] = layer.pane;
     }
     if (layer.minZoom != null && layer.minZoom != undefined) {
       options['minZoom'] = layer.minZoom;
     }
     if (layer.stateName != null && layer.stateName != undefined) {
       options['viewParams'] = 'stateName:' + layer.stateName;
     }
     if (layer.env != null && layer.env != undefined) {
       options['env'] = layer.env;
     }
     if (layer.styles) {
       options['styles'] = layer.styles
     }
     const url = MapConstants.GEOSERVER_WMS_URL;
     layer['layer'] = (L as any).tileLayer.wms(url, options);
     return layer;
   }
 
   async addTimeBasedLayers(gis, layerList) {
     gis.playButtonDisable = true;
     gis.labelStrings = [];
     gis.showThrobber = true;
     delay(0.1);
     for (const index in layerList) {
       if (!isNullOrUndefined(index)) {
         const layer = layerList[index];
         if (layer['type'] == 'Time') {
           const layerObj = this.createLayer(layer, gis);
           layerObj.then(data => {
             layerList[index] = data;
             if (!isNullOrUndefined(layer['layerName'])) {
               if (!isNullOrUndefined(gis.htmlLegend)) {
                 gis.map.removeControl(gis.htmlLegend);
               }
               const htmlLegend = this.createLegend();
               gis.map.addControl(htmlLegend);
               gis.htmlLegend = htmlLegend;
 
               const legendInfoData = this.getLegendData(ColdwaveMapConstants.legendData, data['layer']);
               htmlLegend.addLegend(legendInfoData);
             }
             data['layer'].addTo(gis.map);
             gis.activeLayers.push(data);
             gis.showThrobber = false;
             gis.playButtonDisable = false;
             this.landingService.throbberRunningStatus.throbberHW = false;
           });
         }
       }
     }
   }
 
   createLabels(tsList) {
     const labelStrings = [];
     for (const ts of tsList) {
       labelStrings.push({
         groupName: ts,
         label: {
           label: this.utils.convertModelDatetoDate(ts).toLocaleDateString(),
           toolTip: '5:30 AM - 5:30 AM'
         },
         fullLabel: this.utils.convertModelDatetoDate(ts).toLocaleDateString(),
       });
     }
     return labelStrings;
   }
 
   changeTimeLayers(gis, groupName) {
     if (groupName != gis.activeGroup) {
       gis.activeGroup = groupName;
       for (const index in gis.activeLayers) {
         if (!isNullOrUndefined(index)) {
           const layer = gis.activeLayers[index];
           if (layer['type'] == 'Time' && layer['serviceType'] == 'VectorLayer') {
             for (const uuid of Object.keys(this.mandalData)) {
               let color = '#AAAAAA';
               if (this.mandalData[uuid]['table_data'][groupName]) {
                 color = ProjConstants.COLD_WATCHES_LEGEND[this.mandalData[uuid]['table_data'][groupName]['cat']];
               }
               const style = {
                 fill: true,
                 weight: 0.5,
                 opacity: 1,
                 color: '#000000',
                 fillColor: color,
                 fillOpacity: 1,
               };
               layer['layer'].setFeatureStyle(uuid, style);
             }
           }
         }
       }
     }
   }
 
   addGroupTimeLayers(gis, groupName) {
     for (const index in gis.layerList) {
       if (!isNullOrUndefined(index)) {
         const layer = gis.layerList[index];
         if (layer['type'] == 'Time' && layer['time'] == gis.forecastLength && layer['groupName'] == groupName && layer['view'] == gis.view && (layer['type2'] == undefined || layer['type2'] == gis.minMax)) {
           if (layer['layer'] != null && layer['layer'] != undefined) {
             layer['layer'].addTo(gis.map);
             gis.activeLayers.push(layer);
           }
         }
       }
     }
   }
 
   removeGroupTimeLayers(gis, groupName) {
     for (const index in gis.activeLayers) {
       if (!isNullOrUndefined(index)) {
         const layer = gis.activeLayers[index];
         if (layer['groupName'] == groupName && layer['type'] == 'Time') {
           gis.map.removeLayer(layer['layer']);
           gis.activeLayers[index] = 'deleted';
         }
       }
     }
     gis.activeLayers = gis.activeLayers.filter(item => item != 'deleted');
   }
 
   removeAllTimeLayers(gis) {
     for (const index in gis.activeLayers) {
       if (!isNullOrUndefined(index)) {
         const layer = gis.activeLayers[index];
         if (layer['type'] == 'Time') {
           gis.map.removeLayer(layer['layer']);
           gis.activeLayers[index] = 'deleted';
         }
       }
     }
     gis.activeLayers = gis.activeLayers.filter(item => item != 'deleted');
   }
 
     formatMandalData(data, hval, hcat, gis, actualData?) {
     let totalTableData: any;
     if (actualData.length > 0) {
       totalTableData = this.fetchTotData(actualData, data);
     } else {
       totalTableData = data
     }
     return new Promise((resolve, reject) => {
       const finalData = {};
       const timeStampList = [];
       let currentDate = this.coldwaveDataService.getCurrentDateInYYYYMMDDFormat1();
       for (const locName of Object.keys(data)) {
         if (data[locName]['table_data'] == null || data[locName]['table_data'] == undefined) {
           continue;
         }
         let table_data = {};
         for (const index of totalTableData[locName]['table_data']) {
           if (!timeStampList.includes(index['timeStamp'])) {
             timeStampList.push(index['timeStamp']);
           }
           if (index['timeStamp'] == currentDate && totalTableData[locName]['table_data'].length > 0) {
             for (let actualLocName of Object.keys(totalTableData)) {
               if (totalTableData[actualLocName]['uuid'] == data[locName]['uuid']) {
                 table_data[index['timeStamp']] = {
                   val: totalTableData[actualLocName]['table_data'][0]['data'][hval],
                   cat: totalTableData[actualLocName]['table_data'][0]['data'][hcat]
                 };
               }
             }
 
           } else {
             table_data[index['timeStamp']] = {
               val: index['data'][hval],
               cat: index['data'][hcat]
             };
           }
         }
         const locData = {
           name: data[locName].name,
           pName: data[locName].pName,
           uuid: data[locName].name,
           'table_data': table_data
         };
         finalData[data[locName].uuid] = locData;
       }
       const sortedTimeStampList = this.combinedTimeStampList.sort();
       // const sortedTimeStampList = timeStampList.sort();
       gis.labelStrings = this.createLabels(sortedTimeStampList);      
       let index: any = this.cwDataService.setBlockNumber();
       gis.activeGroup = sortedTimeStampList[index];
       resolve(finalData);
     })
   }
 
     fetchTotData(dataA: any, dataB: any) {
     let objA: any = this.fetchObj(dataA);
     let objB: any = this.fetchObj(dataB);
     let keys: any = Object.keys(objA);
     let finalArr: any = [];
     let obj: any = {}
     for (let i: any = 0; i < keys.length; i++) {
       let obj: any = {};
       obj = { ...obj, ...objA[keys[i]] };
       let newArr: any = [];
       newArr = newArr.concat(objA[keys[i]]['table_data']);
       if(!isNullOrUndefined(objB[keys[i]])) {
         newArr = newArr.concat(objB[keys[i]]['table_data']);
       }
       obj['table_data'] = this.removeDuplicates(newArr);
 
       finalArr.push(obj);
     }
     return finalArr;
   }
 
   fetchObj(data: any) {
     let obj: any = {};
     for (let i: any = 0; i < data.length; i++) {
       obj[data[i]['uuid']] = data[i];
     }
 
     return obj;
   }
 
   removeDuplicates(data: any) {
     const uniqueTimestamps = new Set<number>();
     const filteredData = data.filter(item => {
       if (!uniqueTimestamps.has(item.timeStamp)) {
         uniqueTimestamps.add(item.timeStamp);
         return true;
       }
       return false;
     });
     return filteredData;
   }
 
   createLegend() {
     return new (L as any).Control.HtmlLegend({
       position: 'bottomright',
       collapseSimple: false,
       detectStretched: false,
       collapsedOnInit: false
     });
   }
 
   getLegendData(data, layerInstance) {
     const legend = {
       name: data.title,
       layer: layerInstance,
     };
     legend['elements'] = [];
     const isTrue = 1;
     if (isTrue == 1 && data.levels.length > 0) {
       let html = ``;
       for (let key = 0; key < data.levels.length; key++) {
         if (data.levels[key].image) {
           html += `<p style='height:30px;margin:0px;padding:4px;color:black;background-color: ${data.levels[key].color}'>
            ${data.levels[key].name} <img src='${data.levels[key].image}'></p>`;
         } else {
           html += `<p style='height:20px;margin:0px;padding:4px;color:black;background-color: ${data.levels[key].color}'>${data.levels[key].name}</p>`;
         }
       }
       legend['elements'].push({ html });
     } else if (data.levels) {
       let obj;
       if (!(data.levels instanceof Array)) {
         const periodWiseLegend = {};
         for (const period in data.levels) {
           if (!isNullOrUndefined(period)) {
             const tempLegend = {
               name: data.title,
               layer: layerInstance,
               elements: []
             };
             data.levels[period].forEach(level => {
               obj = {};
               obj['html'] = '';
               if (level['image'] != undefined && level['image'] != '') {
                 obj['html'] = '<img style=\'width:13px;height:13px;\' src=\'' + level['image'] + '\'/>';
               }
               obj['label'] = level.name;
               obj['style'] = { 'background-color': level.color, width: '13px', height: '13px' };
               tempLegend.elements.push(obj);
             });
             periodWiseLegend[period] = tempLegend;
           }
         }
         return periodWiseLegend;
       } else {
         data.levels.forEach(level => {
           obj = {};
           obj['html'] = '';
           if (level['image'] != undefined && level['image'] != '') {
             obj['html'] = '<img style=\'width:13px;height:13px;\' src=\'' + level['image'] + '\'/>';
           }
           obj['label'] = level.name;
           obj['style'] = { 'background-color': level.color, width: '13px', height: '13px' };
           legend['elements'].push(obj);
         });
       }
     }
     return legend;
   }
}
